import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { EditRotationForm } from "../../forms/rotations/editRotationForm";
import { format } from "date-fns";
import type { Dispatch, SetStateAction } from "react";

const EditRotationSheet = ({
  open,
  onOpenChange,
  setRotations,
  rotation,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  setRotations: Dispatch<SetStateAction<{ rotations: any[]; sessions: any[] }>>;
  rotation: any;
}) => {
  const onSuccess = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>
            Edit {format(rotation.date, "MMMM dd, yyyy")} Rotation
          </SheetTitle>
          <SheetDescription>
            Edit {format(rotation.date, "MMMM dd, yyyy")} rotation, and it's
            sessions.
          </SheetDescription>
        </SheetHeader>
        <EditRotationForm
          rotation={rotation}
          onSuccess={onSuccess}
          setRotations={setRotations}
        />
      </SheetContent>
    </Sheet>
  );
};

export { EditRotationSheet };
